import { createAction } from '@reduxjs/toolkit';
import type { UserPrivateMoney, UserPrivateMoneyState } from '../reducers/user-private-money';
import type { AppThunk } from '../store/configureStore';

export const INIT_USER_MONEY = createAction<Partial<UserPrivateMoneyState>>('INIT_USER_MONEY');
export const SET_USER_MONEY = createAction<UserPrivateMoney>('SET_USER_MONEY');
export const SET_USER_PRIVATE_MONEY_HIGHLIGHTED = createAction<
  | {
      isHighlighted: true;
      allowedMoneys: UserPrivateMoney[];
    }
  | { isHighlighted: false }
>('SET_HIGHLIGHTED');

export const initUserPrivateMoney =
  (defaultMoney: UserPrivateMoney, availableMoneys: UserPrivateMoney[]): AppThunk =>
  (dispatch) => {
    const userPrivateMoneyId = localStorage.getItem('userPrivateMoneyId');
    const selectedMoney = userPrivateMoneyId
      ? availableMoneys.find((m) => m.id === userPrivateMoneyId) ?? defaultMoney
      : defaultMoney;
    if (!userPrivateMoneyId) {
      localStorage.setItem('userPrivateMoneyId', selectedMoney.id);
    }
    dispatch(INIT_USER_MONEY({ selectedMoney, availableMoneys }));
  };

export const setUserPrivateMoney =
  (userPrivateMoney: UserPrivateMoney): AppThunk =>
  (dispatch) => {
    localStorage.setItem('userPrivateMoneyId', userPrivateMoney.id);
    dispatch(SET_USER_MONEY(userPrivateMoney));
  };
